import { useMemo } from "react";
import { getMatchIndexes, normalizeSearchValue } from "../utils/demandStudioSearchUtils";

const normalizeValue = (value) => String(value || "");

const useTextareaHighlight = ({ text, searchTerm, activeMatchStartIndex = -1 }) => {
  const sourceText = normalizeValue(text);
  const normalizedTerm = normalizeSearchValue(searchTerm);

  const segments = useMemo(() => {
    if (!normalizedTerm) {
      return [{ text: sourceText, isMatch: false }];
    }

    const nextSegments = [];
    const matchIndexes = getMatchIndexes({
      source: sourceText.toLowerCase(),
      query: normalizedTerm,
    });
    let cursor = 0;

    matchIndexes.forEach((matchIndex) => {
      if (matchIndex > cursor) {
        nextSegments.push({
          text: sourceText.slice(cursor, matchIndex),
          isMatch: false,
          startIndex: cursor,
        });
      }

      const matchEndIndex = matchIndex + normalizedTerm.length;
      nextSegments.push({
        text: sourceText.slice(matchIndex, matchEndIndex),
        isMatch: true,
        startIndex: matchIndex,
        isActive: matchIndex === activeMatchStartIndex,
      });
      cursor = matchEndIndex;
    });

    if (cursor < sourceText.length) {
      nextSegments.push({
        text: sourceText.slice(cursor),
        isMatch: false,
        startIndex: cursor,
      });
    }

    if (!nextSegments.length) {
      return [{ text: sourceText, isMatch: false, startIndex: 0 }];
    }

    return nextSegments;
  }, [sourceText, normalizedTerm, activeMatchStartIndex]);

  return {
    segments,
    hasMatches: normalizedTerm.length > 0 && segments.some((segment) => segment.isMatch),
  };
};

export default useTextareaHighlight;
